import { render, staticRenderFns } from "./HeaderHorizonMenu.vue?vue&type=template&id=89580120&scoped=true"
import script from "./HeaderHorizonMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderHorizonMenu.vue?vue&type=script&lang=ts"
import style0 from "./HeaderHorizonMenu.vue?vue&type=style&index=0&id=89580120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89580120",
  null
  
)

export default component.exports